<template>
  <div class="basic_wrap">
    <div class="red_top_bg">
      <div class="big_tit">
        {{ $t('home.item') }}
      </div>
    </div>
    <div class="item_wrap">
      <!--<div class="tabs">
        <van-tabs
          v-model="active"
          @click="sort"
        >
          <van-tab
            v-for="index in tabs"
            :key="index"
            :title="index" 
          />
        </van-tabs>
        <van-empty
          v-if="listLength == 0"
          :description="$t('item.noData')"
        />
      </div>-->
      <div class="items_3 item_margin">
        <div
          v-for="i in data.list"
          :key="i.id"
          class="item"
        >
          <div
            class="item_img"
            @click="$router.push('/item/'+i.id)"
          >
            <img :src="i.img">
          </div>
          <div
            class="item_div1"
            @click="$router.push('/item/'+i.id)"
          >
            <p style="color: rgb(255, 255, 255);font-size: 14px; text-align: left; font-weight: 800;">
              {{ i[lang] }}
            </p>
          </div>
          <div
            class="item_div2"
            @click="$router.push('/item/'+i.id)"
          >
            <div class="item_rate">

			  <p>{{i.day}}{{i.type==3?$t('utils.hour'):$t('utils.day')}}</p>
			  <p >{{ $t('utils.cycle') }}</p> 
            </div>
            <div class="item_day">
              <p style="color: #FFFFFF;">{{ i.min }}</p>
              <p>{{ $t('search.notFound') }}</p>
            </div>
			

		  <div class="item_min">
		  <p style="color: #FFFFFF;">{{ i.rate }}%</p>
		  <p>{{ $t('utils.dailyIncome') }}</p>
		  </div>
		  
           <div class="item_rate">
              <p>{{ (i.min*i.rate/100).toFixed(2) }}</p>
              <p>{{ $t('index.dailyIncome') }}</p>
            </div>
			

          </div>
		  <div class="item_div4"
		  @click="$router.push('/item/'+i.id)"
		  >
		    <div class="item_btn">
		      <button type="button">
		        {{ $t('utils.invest') }}
		      </button>
		    </div>
		  </div>
          <!--<div
            class="item_div3"
            :class="lang=='zh_cn'||lang=='zh_hk'||lang=='ko_kr'||lang=='ja_jp'?'item_div3_2':'item_div3_1'"
          >
            投资周期<p>{{$t('utils.cycle')}}:{{i.day}}{{i.type==3?$t('utils.hour'):$t('utils.day')}}</p> 
           <p>{{i.typeName}}</p>
            <p>{{ $t('item.tab2') }}</p>
            <p>{{ $t('index.dailyIncome') }}:{{ (i.min*i.rate/100).toFixed(2) }}</p>
          </div>-->
          <!--<div class="item_div4">
            投资进度<van-progress :percentage="i.percent" />
            <div class="item_btn">
              <button type="button" @click="buy(i)">{{$t('utils.invest')}}</button>
              <button
                type="button"
                @click="$router.push('/item/'+i.id)"
              >
                {{ $t('utils.invest') }}
              </button>
            </div>
          </div>-->
        </div>
      </div>
      <van-dialog
        v-model="show_tz" 
        show-cancel-button
        :confirm-button-text="$t('utils.confirm')"
        :cancel-button-text="$t('utils.cancel')"
        @confirm="confirm"
      >
        <div class="items_3">
          <div class="item">
            <div class="item_div1">
              <p>
                {{ sku[lang] }}
              </p>
            </div>
            <div class="item_div2">
              <div class="item_rate">
                <p>{{ sku.rate }}%</p>
                <p>{{ $t('utils.dailyIncome') }}</p>
              </div>
              <!-- 					投资周期<div class="item_day">
							<p>{{sku.day}}{{sku.type==3?$t('utils.hour'):$t('utils.day')}}</p>
							<p>{{$t('utils.cycle')}}</p>
						</div> -->
              <div class="item_min">
                <p>{{ sku.min }}</p>
                <p>{{ $t('utils.startingAmount') }}</p>
              </div>
            </div>
          </div>
        </div>
        <van-field
          v-model="number"
          type="number"
          :placeholder="$t('item.inputAmount')"
          @input="input()"
        >
          <template #button>
            <van-button>{{ $t('index.totalIncome') }}:{{ countIncome }}</van-button>
          </template>
        </van-field>
      </van-dialog>
    </div>
  </div>
</template>
<script>
    import Fetch from '../../utils/fetch';
	import Api from "../../interface/index"
	import Vue from 'vue';
	import { Tab, Tabs ,Progress,Empty,Dialog,Field} from 'vant';
	Vue.use(Tab).use(Tabs).use(Progress).use(Empty).use(Dialog).use(Field);
    export default {
        name: "Item",
        data() {
            return {
				lang:this.$i18n.locale||"zh_cn",
				tabs:[
					this.$t('item.all'),
					this.$t('item.tab1'),
					this.$t('item.tab2'),
					this.$t('item.tab3'),
					this.$t('item.tab4'),
					this.$t('item.tab5')
				],
				active:0,
                data: [],
				listLength: 0,
				show_tz:false,
				number: "",
				countIncome:0,
				sku:[]
            }
        },
        created() {
            this.$parent.footer('item');
        },
        mounted() {
			var type = 0;
			if(this.$router.history.current.query.type){
				this.active = parseInt(this.$router.history.current.query.type);
				type = this.$router.history.current.query.type;
			}
            this.start(type);
        },
        methods: {
            start(type) {
                Fetch('/index/item_search', {
					name: "",
					index_type:type
                }).then(r => {
                    this.data = r.data;
					this.listLength = r.data.list.length;
                })
            },
			sort(type){
			   this.start(type);
			},
			input(){
				 
				this.countIncome = parseFloat((this.number*100/100).toFixed(2)) + parseFloat((this.number*this.sku.rate*this.sku.day/100).toFixed(2));
			},
			buy(item){
				this.sku = item;
				this.number = "";
				this.countIncome = 0;
				this.show_tz = true;
			},
			confirm(){
				if(!this.number){
					this.$toast(this.$t('item.inputAmount'));
					return false;
				}
				Fetch("/index/item_apply", {
				  id: this.sku.id,
				  money:this.number
				}).then(r => {
				  this.$router.push("/order");
				}).catch(err=>{
				    // this.psd_val = '';
				})
			}
        }
    }
</script>

<style lang="less" scoped>
	/deep/ .van-cell{
		padding: 15px 26px;
	}
    .red_top_bg {
        position: fixed;
        top: 0;
        z-index: 10;
    }

    .basic_wrap {
        position: relative;
    }
    .item_wrap {
        width: 100%;
        padding: 4px 0 0 0;
		background: linear-gradient(#00165a, #161e32);
		background-size: 100% auto;
		.tabs{
			position: fixed;
			z-index: 100;
		}
    }
	.item_margin{
		margin-top: 54px!important;
	}
	.items_3
	{
		margin: 10px 2% 0 2%;
		width: 96%;
		.item{
		background: url(../images/item/bg.gif) no-repeat center center;
			
		}
	}
	.items_3 {
		.item{
			margin-bottom: 10px;
			
			
			div{
				margin: 5px 0;
			}
			.item_img{
				margin: 0;
				padding: 5px;
				img{
					width: 100%;
					border-radius: 15px;
				}
			}
			.item_div1{
				display: flex;
				text-align: center;
				justify-content: space-between;
				border-bottom: 1px solid #774b4b00;
				padding: 5px 10px;
				margin-top: -31px;
				flex-direction: column;
				p:nth-child(1){
					// width: 90%;
					font-weight: bold;
					overflow:hidden;
					text-overflow:ellipsis;
					white-space:nowrap;
					
				}
				p:nth-child(2){
					color: #ffd01e;
				}
			}
			.item_div2{
				display: flex;
				justify-content: space-between;
				text-align:center;
				font-size: 14px;
				div{
					width: 50%;
					p{
						padding: 5px 0;
					}
				}
				.item_rate{
					p:nth-child(1){
						font-weight: bold;
						color: #FF0000;
						
					}
					p:nth-child(2){
						color: #ffd01e;
					}
				}
				.item_day{
					
					
					p:nth-child(1){
						font-weight: bold;
					}
					p:nth-child(2){
						color: #ffd01e;
					}
				}
				.item_min{
					p:nth-child(1){
						font-weight: bold;
						
					}
					p:nth-child(2){
						color: #ffd01e;
					}
				}
			}
			.item_div3{
				color: #ffd01e;
				padding: 5px 10px;
			}
			.item_div3_1{
				p:nth-child(1){
					margin-bottom: 10px;
				}
			}
			.item_div3_2{
				display: flex;
				justify-content: space-between;
			}
			.item_div4{
				padding: 5px 10px;
				
				justify-content: space-between;
				div:nth-child(1){
					/* width: 100%;
					margin-top: 16px;
 				width: 75%;
				   margin-top: 16px; */
				}
 				/*.item_btn{
					width: 20%;
					button{
						min-width: 60px;
						color: #1989fa;
						padding: 5px 5px;
						border-radius: 5px;
						border: 1px solid #1989fa;
					}
				} */
				.item_btn{
						text-align: center;
						button{
						width: 60%;
						min-width: 60px;
						background: #082d9e;
						color: #FFFFFF;
						padding: 10px 0px;
						border-radius: 10px;
						box-shadow: 0 0 5px 5px #1989fa;
					}
				}
			}
		}
	}
	/deep/ .van-tabs__line {
		height: 2px;
		background-color: #1989fa;
	}
	/deep/ .van-tab--active{
		color: #1989fa;
	}
	/deep/ .van-field__button{
		color: #ffd01e;
	}
</style>
